import WithImageModal from './component'

export default WithImageModal
